import * as ActionTypes from '../actions/ActionTypes';
const INITIAL_STATE = {};
export default function theme(state = INITIAL_STATE, {
  payload,
  type
}) {
  switch (type) {
    case ActionTypes.FETCH_TEMPLATE_SETTINGS_SUCCESS:
      return payload.theme;
    default:
      return state;
  }
}